import { breadcrumbAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const style = createMultiStyleConfigHelpers(breadcrumbAnatomy.keys);

export const baseStyle = style.definePartsStyle((props) => {
  return {
    item: {
      fontSize: 'xs',
      fontWeight: '600',
      color: props.theme.colors.palette.primary[50],
      lineHeight: '1',
    },
    link: {
      fontSize: 'xs',
      lineHeight: '1',
      ':hover': {
        textDecoration: 'underline',
        color: props.theme.colors.palette.primary[30],
      },
    },
  };
});
export const Breadcrumb = style.defineMultiStyleConfig({ baseStyle });
